import React, { useEffect, useState } from 'react'
import { Button, TextField, FormControl, FormControlLabel, RadioGroup, Radio, Backdrop, Box } from '@mui/material'
import AppLoader from '../../../components/AppLoader/AppLoader';
import { useFormik } from 'formik'
import * as Yup from 'yup';
import LoadScheddingBlock from '../../../components/loadsheddingblock/loadscheddingblock'
import './LoadManagement.scss'
import Error from '../../../components/error/error';
import { dBillAPI } from '../../../services/Functions';
import { useSelector } from 'react-redux';
import { cpBaseUrl } from '../../../network/urls';

const HOUR_NUMBERS = Array.from({ length: 24 }, (_, i) => String(i + 1).padStart(2, '0'));

const LoadManagement = () => {

    const initialValues = {
        iv_reference_number: '',
        iv_consumer_id: ''
    }

    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [error, setError] = useState('')
    const [searchBy, setSearchBy] = useState('consumerId');
    const { token } = useSelector((state) => state.auth);
    const [loadScheddingData, setLoadScheddingData] = useState()

    const SearchBy = (event) => {
        values.iv_search_by = event.target.value;
        setSearchBy(event.target.value);
        values.iv_consumer_id = ''
        values.iv_reference_number = ''
        setLoadScheddingData()
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_reference_number: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'referenceNo',
                then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
                otherwise: Yup.string().optional()
            }),
            iv_consumer_id: Yup.string().when('iv_search_by', {
                is: () => searchBy === 'consumerId',
                then: Yup.string().min(10, 'Customer ID. must be 10 digits.').max(10, 'Customer ID. must be 10 digits.').required("Enter consumer Id."),
                otherwise: Yup.string().optional()
            }),
        }),
        onSubmit: async (values) => {
            if (searchBy === 'referenceNo') {
                setViewBackdrop(true)
                let requestOptions = {
                    method: 'GET',
                    redirect: 'follow',
                };

                await fetch(cpBaseUrl + "?refno=" + values.iv_reference_number, requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.tblStatus[0].status === true) {
                            let feederCode = result.Table[0].FEEDERCD
                            let myHeaders = new Headers();
                            myHeaders.append("Cookie", "ccms_session=eyJpdiI6IndJaUpBUDduQVUybVJwTWJ2WCtERkE9PSIsInZhbHVlIjoiNGhlaXRWdlY2cWh0bnFiUldRcklqb1lPWExZQ3BjZ2t1dlpPOGduQUs1ZzhOeTcyejZXU0U3ekpaVXNKSVZ2aiIsIm1hYyI6IjM3NThlMjJhNjk2NWQ0NjdiY2ZiM2NlY2FkN2FkNmM0OWY5ODkzYjAwZDA5ZmMzZWFkZDNhOGQzZmVlM2Q5MjgifQ%3D%3D");
                            let requestOptions = {
                                method: 'GET',
                                headers: myHeaders,
                                redirect: 'follow',
                            };

                            fetch("https://ccms.pitc.com.pk/api/search_feeder_schedule?feeder_code=" + feederCode + "&disco_code=" + values.iv_reference_number.slice(2, 4) + "000", requestOptions)
                                .then(response => response.json())
                                .then(result => {
                                    setLoadScheddingData(result.server_response[0])
                                    setViewBackdrop(false)
                                })
                                .catch(() => {});
                        }
                        else {
                            setError('Reference number not exists!')
                            setViewBackdrop(false)
                        }
                    })
                    .catch(() => {});
            }
            else if (searchBy === 'consumerId') {
                setViewBackdrop(true)
                let apiResponse = await dBillAPI(token, values.iv_consumer_id)
                if (apiResponse.status) {
                    let referenceNo = apiResponse.basicInfo.refNo.replace(/ /g, "").slice(0, 14)
                    let requestOptions = {
                        method: 'GET',
                        redirect: 'follow',
                    };

                    await fetch(cpBaseUrl + "?refno=" + referenceNo, requestOptions)
                        .then(response => response.json())
                        .then(result => {
                            if (result.tblStatus[0].status === true) {
                                let feederCode = result.Table[0].FEEDERCD
                                let myHeaders = new Headers();
                                myHeaders.append("Cookie", "ccms_session=eyJpdiI6IndJaUpBUDduQVUybVJwTWJ2WCtERkE9PSIsInZhbHVlIjoiNGhlaXRWdlY2cWh0bnFiUldRcklqb1lPWExZQ3BjZ2t1dlpPOGduQUs1ZzhOeTcyejZXU0U3ekpaVXNKSVZ2aiIsIm1hYyI6IjM3NThlMjJhNjk2NWQ0NjdiY2ZiM2NlY2FkN2FkNmM0OWY5ODkzYjAwZDA5ZmMzZWFkZDNhOGQzZmVlM2Q5MjgifQ%3D%3D");
                                let requestOptions = {
                                    method: 'GET',
                                    headers: myHeaders,
                                    redirect: 'follow',
                                };

                                fetch("https://ccms.pitc.com.pk/api/search_feeder_schedule?feeder_code=" + feederCode + "&disco_code=" + referenceNo.slice(2, 4) + "000", requestOptions)
                                    .then(response => response.json())
                                    .then(result => {
                                        setLoadScheddingData(result.server_response[0])
                                        setViewBackdrop(false)
                                    })
                                    .catch(() => {});
                            }
                            else {
                                setError('Customer ID. does not exists!')
                                setViewBackdrop(false)
                            }
                        })
                        .catch(() => {});
                } else {
                    setError('Customer ID. not found!')
                    setViewBackdrop(false)
                }
            }
        }
    })

    useEffect(() => {
        if (values.iv_reference_number.length < 14) {
            setLoadScheddingData()
        }
    }, [values.iv_reference_number])

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSubmit();
        }
    };

    const errorCloses = () => {
        setError('')
    }

    return (
        <>
            <Box className="form-box load-shedding-form-box">
            <div className="load-shedding-page">
                <div className="load-shedding-page__header">
                    <h1>Load Shedding Schedule</h1>
                </div>

                <div className="load-shedding-page__body">
                    <form onSubmit={handleSubmit}>
                            <div className="load-shedding-section-title">Connection Details</div>

                            <div className="load-shedding-search">
                                <div className="load-shedding-search__field">
                                    <span className="load-shedding-search__label">Search By</span>
                                    <FormControl>
                                        <RadioGroup
                                            className="load-shedding-search__radios"
                                            row
                                            name="iv_search_by"
                                            value={searchBy}
                                            onChange={SearchBy}
                                        >
                                            <FormControlLabel
                                                value="consumerId"
                                                control={<Radio size="small" />}
                                                label="Customer ID."
                                            />
                                            <FormControlLabel
                                                value="referenceNo"
                                                control={<Radio size="small" />}
                                                label="Reference No."
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </div>

                                {searchBy === 'consumerId' && (
                                    <div className="load-shedding-search__field">
                                        <span className="load-shedding-search__label">Customer ID.</span>
                                        <TextField
                                            className="load-shedding-search__input"
                                            inputProps={{ maxLength: 10 }}
                                            size="small"
                                            type="text"
                                            autoComplete="off"
                                            name="iv_consumer_id"
                                            value={values.iv_consumer_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onKeyPress={handleKeyPress}
                                            id="iv_consumer_id"
                                        />
                                        {errors.iv_consumer_id && touched.iv_consumer_id && (
                                            <span className="load-shedding-search__error">{errors.iv_consumer_id}</span>
                                        )}
                                    </div>
                                )}

                                {searchBy === 'referenceNo' && (
                                    <div className="load-shedding-search__field">
                                        <span className="load-shedding-search__label">Reference No.</span>
                                        <TextField
                                            className="load-shedding-search__input"
                                            inputProps={{ maxLength: 14 }}
                                            size="small"
                                            type="text"
                                            autoComplete="off"
                                            name="iv_reference_number"
                                            value={values.iv_reference_number}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            onKeyPress={handleKeyPress}
                                            id="iv_reference_number"
                                        />
                                        {errors.iv_reference_number && touched.iv_reference_number && (
                                            <span className="load-shedding-search__error">{errors.iv_reference_number}</span>
                                        )}
                                    </div>
                                )}

                                <Button
                                    className="load-shedding-search__submit"
                                    variant="contained"
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            </div>
                        </form>

                        {error && (
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        )}

                        <div className="load-shedding-info-bar">
                            <div className="load-shedding-info-bar__item">
                                <span className="load-shedding-info-bar__label">Feeder</span>
                                <span className="load-shedding-info-bar__value">{loadScheddingData ? loadScheddingData.Feeder : '-'}</span>
                            </div>
                            <div className="load-shedding-info-bar__item">
                                <span className="load-shedding-info-bar__label">Grid</span>
                                <span className="load-shedding-info-bar__value">{loadScheddingData ? loadScheddingData.Grid : '-'}</span>
                            </div>
                            <div className="load-shedding-info-bar__item">
                                <span className="load-shedding-info-bar__label">Feeder Status</span>
                                <span className="load-shedding-info-bar__value">{loadScheddingData ? loadScheddingData.Feeder_Status : '-'}</span>
                            </div>
                        </div>

                        <div className="load-shedding-legend">
                            <div className="load-shedding-legend__item">
                                <span className="load-shedding-legend__swatch load-shedding-legend__swatch--on" />
                                <span>Power On</span>
                            </div>
                            <div className="load-shedding-legend__item">
                                <span className="load-shedding-legend__swatch load-shedding-legend__swatch--off" />
                                <span>Load Shedding</span>
                            </div>
                            <div className="load-shedding-legend__item">
                                <span className="load-shedding-legend__swatch load-shedding-legend__swatch--unknown" />
                                <span>No Data</span>
                            </div>
                        </div>

                        <div className="load-shedding-grid">
                            {HOUR_NUMBERS.map((hour, index) => (
                                <LoadScheddingBlock
                                    key={hour}
                                    number={hour}
                                    lightStatus={loadScheddingData ? loadScheddingData.planned_sch[index] : -1}
                                />
                            ))}
                        </div>
                </div>
            </div>
            </Box>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop>
        </>
    )
}

export default LoadManagement
